import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CategoryStateService {
  catList:any[] = [];
  constructor() { }
}
